export const platformConsoleTenantsContractVersion =
  "platform-console-tenants-v1" as const;

export type PlatformConsoleTenantsContractVersion =
  typeof platformConsoleTenantsContractVersion;

export const platformConsoleTenantsRoutePath =
  "/api/v1/platform-console/tenants" as const;

export const platformConsoleCreateTenantContractVersion =
  "platform-console-create-tenant-v1" as const;

export type PlatformConsoleCreateTenantContractVersion =
  typeof platformConsoleCreateTenantContractVersion;

export const platformConsoleCreateAdminContractVersion =
  "platform-console-create-admin-v1" as const;

export type PlatformConsoleCreateAdminContractVersion =
  typeof platformConsoleCreateAdminContractVersion;

export const platformConsoleCreateAdminRoutePathPattern =
  "/api/v1/platform-console/tenants/{tenantKey}/admin" as const;

export interface PlatformConsoleTenantCountsV1 {
  patients: number;
  workforceSubjects: number;
  conversations: number;
  outboundCampaigns: number;
}

export interface PlatformConsoleTenantSummaryV1 {
  tenantKey: string;
  slug: string;
  displayName: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  counts: PlatformConsoleTenantCountsV1;
}

export interface PlatformConsoleTenantsResponseV1 {
  schemaVersion: PlatformConsoleTenantsContractVersion;
  generatedAt: string;
  tenants: PlatformConsoleTenantSummaryV1[];
}

export interface PlatformConsoleCreateTenantRequestV1 {
  schemaVersion: PlatformConsoleCreateTenantContractVersion;
  tenantKey: string;
  tenantSlug: string;
  displayName: string;
  defaultLocale?: string | null;
  defaultTimeZone?: string | null;
}

export interface PlatformConsoleCreateTenantResponseV1 {
  schemaVersion: PlatformConsoleCreateTenantContractVersion;
  tenant: PlatformConsoleTenantSummaryV1;
}

export interface PlatformConsoleCreateAdminRequestV1 {
  schemaVersion: PlatformConsoleCreateAdminContractVersion;
  tenantKey: string;
  email: string;
  displayName: string;
  temporaryPassword: string;
}

export interface PlatformConsoleCreateAdminResponseV1 {
  schemaVersion: PlatformConsoleCreateAdminContractVersion;
  tenantKey: string;
  subjectKey: string;
  email: string;
}
